import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import Router from 'vue-router';
import router from './router';
import store from './store';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

// const whiteList = ['/login', '/auth-redirect'] // 没有重定向白名单
const whiteList = ['/login', '/404'];

window.localStorage.setItem('storageAside', '0');

router.beforeEach(async (to, from, next) => {
  // 开始进度条
  NProgress.start(); //页面顶部加载进度条

  // 设置页面标题
  document.title = getPageTitle(to.meta.title);

  // 设置页面标题
  const hasToken = getToken();

  if (hasToken) {
    if (
      to.path === '/login' &&
      window.localStorage.getItem('storageAside') === '0'
    ) {
      // 如果已登陆，则重定向到主页
      next({ path: '/' });
      NProgress.done();
    } else {
      // 通过getInfo判断用户是否获得了权限角色
      const permission_routes =
        store.getters.permission_routes &&
        store.getters.permission_routes.length > 0;

      if (permission_routes) {
        next();
      } else {
        try {
          await store.dispatch('user/getInfo'); // 获取用户信息
          const accessRoutes = store.getters.permission_routes; //拿到后台给到的权限菜单
          window.localStorage.setItem('storageAside', '1');
          // 动态添加可访问路由
          router.options.routes = accessRoutes;
          router.matcher = new Router().matcher;
          router.addRoutes(router.options.routes);
          // router.addRoutes(accessRoutes)

          // hack method ，以确保地址是完整的
          // 设置replace: true，这样导航将不会留下历史记录
          next({ ...to, replace: true });
          // next()
        } catch (error) {
          console.log(error);
          // 移除令牌，转到登录页面重新登录
          await store.dispatch('user/resetToken');
          // Message.error({ message: error || 'Has Error' });
          next(`/login?redirect=${to.path}`);
          // next(`/login`);
          NProgress.done();
        }
      }
    }
  } else {
    /* 没有 token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // 在自由登录白名单中，直接进入
      next();
    } else {
      // 其他没有访问权限的页面被重定向到登录页面。
      next(`/login?redirect=${to.path}`);
      // next(`/login`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // 完成进度条
  NProgress.done();
});
